module.exports = __webpack_public_path__ + "img/image2.8b8efe55.jpg";